// App.js
import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Outlet, useLocation } from "react-router-dom";
import "./App.css";
import TopBar from "./components/TopBar";
import "./customStyles/modals.css";
import { ROUTES } from "./utils/constants";
import girarTablet from "./assets/girar-tablet.png"
import { MediaProvider } from "./contexts/MediaContext";

function App() {
	const location = useLocation();
	const dispatch = useDispatch();

	const noTopBarScreens = [
		ROUTES.HOME,
		ROUTES.REGISTER,
		ROUTES.PRESENTATION,
		ROUTES.START_GAME,
		ROUTES.START_GAME2,
		ROUTES.START_GAME3,
		ROUTES.START_GAME4,
		ROUTES.START_GAME5,
		ROUTES.SCENARIO1_INTRO,
		ROUTES.SCENARIO1_INTRO2,
		ROUTES.SCENARIO5_FIN,
		ROUTES.CONGRATULATIONS,
		ROUTES.END,
		ROUTES.RESULTS,
		ROUTES.GAMEOVER,
		ROUTES.WARMUP,
		ROUTES.FINAL_SCENE
	];
	const showTopBar = !noTopBarScreens.some(
		(x) => location.pathname.toString() === x
	);

	// Deshabilitado temporalmente: permitir jugar en móvil sin forzar orientación.
	const forceLandscape = false;

	const [isPortrait, setIsPortrait] = useState(() => {
		if (typeof window === "undefined") return false;
		return window.matchMedia("(orientation: portrait)").matches;
	});

	const [isTouchDevice, setIsTouchDevice] = useState(false);

	useEffect(() => {
		if (typeof window === "undefined") return;

		setIsTouchDevice(
			"ontouchstart" in window || navigator.maxTouchPoints > 0
		);

		const mql = window.matchMedia("(orientation: portrait)");
		const onChange = (e) => setIsPortrait(e.matches);

		if (mql.addEventListener) {
			mql.addEventListener("change", onChange);
		} else {
			mql.addListener(onChange);
		}

		// Fallback por si no dispara el change en algún navegador
		const onResize = () =>
			setIsPortrait(window.matchMedia("(orientation: portrait)").matches);
		window.addEventListener("resize", onResize);

		return () => {
			if (mql.removeEventListener) {
				mql.removeEventListener("change", onChange);
			} else {
				mql.removeListener(onChange);
			}
			window.removeEventListener("resize", onResize);
		};
	}, []);

	// En móvil, al navegar entre pantallas evitamos quedar “a mitad de scroll”.
	useEffect(() => {
		if (typeof window === "undefined") return;
		try {
			// Scroll global (body/html)
			window.scrollTo({ top: 0, left: 0, behavior: "auto" });
			document.documentElement.scrollTop = 0;
			document.body.scrollTop = 0;

			// Si el scroll está en un contenedor (p. ej. `.App`), reinícialo también.
			const appScroll = document.querySelector(".App");
			if (appScroll) appScroll.scrollTop = 0;

			// Reinicia scrolls internos típicos del layout sg5.
			document.querySelectorAll(".sg5-scroll").forEach((el) => {
				el.scrollTop = 0;
			});
		} catch {
			/* noop */
		}
	}, [location.pathname]);

	window.onbeforeunload = function () {
		return "Your work will be lost.";
	};

	return (
		<MediaProvider>
			<div className={`App ${showTopBar ? "" : ""}`}>
				{showTopBar && <TopBar></TopBar>}
				<Outlet />
			</div>
			{forceLandscape && isTouchDevice && isPortrait && (
				<div className="d-flex orientation-overlay px-5">
					<img src={girarTablet} style={{maxWidth: "240px"}}/>
					<p className="txtTexto3 ps-5 txtWhite">
						Para una mejor experiencia, use la tablet en{" "}
						<strong>orientación horizontal</strong> durante todo el juego.
					</p>
				</div>
			)}
		</MediaProvider>
	);
}
export default App;
